import onwords from '../Assets/Images/onwords-in.png'
import pscastle from '../Assets/Images/ps-castel.png'
import foodon from '../Assets/Images/food-on.png'
const Projects=[
    {
        id:1,
        img:onwords,
        Name:'Onwords',
        desc:`I'm  a frontend web developer fueled by a passion for crafting funky and interactive digital experiences. I thrive on translating ideas into captivating visuals and seamless user interactions using a blend of HTML, CSS, and JavaScript wizardry.   My goal? To sprinkle a touch of excitement and creativity into every project, `,
        links:'https://onwords.in/',
    },
    {
        id:2,
        img:pscastle,
        Name:'PS Castle',
        desc:`I'm  a frontend web developer fueled by a passion for crafting funky and interactive digital experiences. I thrive on translating ideas into captivating visuals and seamless user interactions using a blend of HTML, CSS, and JavaScript wizardry.   My goal? To sprinkle a touch of excitement and creativity into every project, `,
        // links:'https://onwords.in/',
    },
    {
        id:3,
        img:foodon,
        Name:'Food On website',
        desc:`I'm  a frontend web developer fueled by a passion for crafting funky and interactive digital experiences. I thrive on translating ideas into captivating visuals and seamless user interactions using a blend of HTML, CSS, and JavaScript wizardry.   My goal? To sprinkle a touch of excitement and creativity into every project, `,
        // links:'https://onwords.in/',
    },

]
export default Projects